<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M9 6v12l10-6-10-6Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
  </svg>
</template>

